import { IoSearch, IoClose } from 'react-icons/io5'
import { Field, Icon, Input, InputGroup, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FormLabel } from 'uikit'
import { useDebounce } from 'use-debounce'

export const InputCardSearch = ({
  onChange = null,
  defaultValue = '',
  value = '',
  placeholder,
  label,
  name = 'search',
  hideIcon = false,
  ...props
}) => {
  const [text, setText] = useState(defaultValue ? defaultValue : value)
  const [valueDebounce] = useDebounce(text, 700)
  const maxSize = 16
  const isInvalid = text.length < maxSize && text.length !== 0

  useEffect(() => {
    if (value !== valueDebounce) {
      if (valueDebounce.length === maxSize || valueDebounce.length === 0) {
        onChange && onChange(valueDebounce)
      }
    }
  }, [valueDebounce])

  useEffect(() => {
    if (value !== text) {
      setText(value)
    }
  }, [value])

  return (
    <Field.Root invalid={isInvalid}>
      {label && <FormLabel name={name}>{label}</FormLabel>}
      <InputGroup
        width="100%"
        endElement={
          text ? (
            <IoClose cursor="pointer" size="20px" color="gray.600" onClick={() => setText('')} />
          ) : (
            !hideIcon && <IoSearch size="20px" color="gray.300" />
          )
        }
      >
        <Input
          id={name}
          value={text || ''}
          onChange={(e) => {
            e.target.value.length <= maxSize && setText(e.target.value)
          }}
          placeholder={placeholder}
          {...props}
        />
      </InputGroup>
      <Text fontSize="0.76rem" opacity="0.5" mt={1}>
        {text.length} из {maxSize}
      </Text>
    </Field.Root>
  )
}
